import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

/**
 * Bitácora de accesos a la plataforma (`accessLogs`).
 *
 * El registro lo crea el login al completarse la sesión; Auditoría →
 * Historial de Acceso lo consulta. No se edita desde la UI.
 */
@Injectable({ providedIn: 'root' })
export class AccessLogsService extends ApiBaseService<any> {
  constructor() {
    super('accessLogs');
  }
}
